module.exports = (__webpack_require__(99410))(20);